import {TosterMessageService} from './../../services/toster-message.service';
import {CustomColumnService} from './../../services/custom-column.service';
import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-default-column',
  templateUrl: './default-column.component.html',
  styleUrls: ['./default-column.component.scss'],
  providers: [CustomColumnService, TosterMessageService]
})
export class DefaultColumnComponent implements OnInit {
  @Input('customizedColumns') customizedColumns: any;
  @Input('tableID') tableID: any;
  @Output() defaultColumnUpdate: EventEmitter<any> = new EventEmitter();
  userColumn: any = [];
  itemSearchkey: string;

  constructor(private customColumnService: CustomColumnService,
              private tosterMessageService: TosterMessageService) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.saveDefaultColoumns();
  }

  saveDefaultColoumns() {
    let that = this;
    this.customColumnService
      .updateDefaultColumn()
      .post({userColumn: this.customizedColumns, tableID: this.tableID})
      .subscribe(resp => {
        // that.tosterMessageService.showSuccess("Success", "Employee Table Configuration saved successfully");
        this.defaultColumnUpdate.emit(this.customizedColumns);
      }, (error) => {
        // that.tosterMessageService.showError("Error", error.data.message);
      });
  }

  restoreDefault(ev: Event) {
    ev.preventDefault();
    let that = this;
    this.customColumnService
      .restoreDefault()
      .post({tableID: this.tableID})
      .subscribe(resp => {
        this.customizedColumns = resp.data.data;
        this.defaultColumnUpdate.emit(resp.data.data);
        // that.tosterMessageService.showSuccess("Success", "Employee Table Configuration restored successfully");
      }, (error) => {
        // that.tosterMessageService.showError("Error", error.data.message);
      });
  }

  cancelColoumns() {
    this.defaultColumnUpdate.emit(this.customizedColumns);
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/default-column/default-column.component.ts